import { Typography } from "@mui/material";
import React from "react";

/**
 * Reusable Page Title Component
 * @param {string} text - The title text
 * @param {string} [color="primary.main"] - The color of the title (optional)
 * @param {string} [variant="h4"] - The typography variant (optional)
 * @param {string} [component="h2"] - The component type (optional)
 */
const PageTitle = ({ text, color = "primary.main", variant = "h4", component = "h2", ...props }) => {
  return (
    <Typography variant={variant} component={component} gutterBottom color={color} {...props}>
      {text}
    </Typography>
  );
};

export default PageTitle;
